module.exports = __webpack_public_path__ + "img/ksrk.66608ff.png";